export default __webpack_public_path__ + "static/media/ride-red.bfac8c7a.svg";